import { IMilestoneTemplate } from "@/interfaces";

export const addMilestoneInList = (
  milestones: IMilestoneTemplate[],
  target: IMilestoneTemplate,
  newMilestone: IMilestoneTemplate,
  location: "before" | "after"
): void => {
  const targetInList = milestones.findIndex(
    (milestone) => milestone.id === target.id
  );
  if (targetInList < 0) {
    for (const milestone of milestones) {
      if (!milestone.childMilestones?.length) continue;

      addMilestoneInList(
        milestone.childMilestones,
        target,
        newMilestone,
        location
      );
    }
  } else {
    switch (location) {
      case "before": {
        milestones.splice(targetInList, 0, newMilestone);
        break;
      }
      case "after": {
        milestones.splice(targetInList + 1, 0, newMilestone);
        break;
      }
      default:
        break;
    }
  }
};
